import { Card } from "../_shared/card";
import { IconAligner } from "../_shared/icons";
import { ProgressArc } from "../_shared/progress-arc";
import { navigate } from "../_shared/router";
import { alignerProgress, children } from "../_data/mock";

export function AlignersCard() {
  return (
    <Card
      title="Aligneurs"
      icon={<IconAligner width={22} height={22} />}
      onClick={() => navigate("aligners")}
    >
      <div className="flex items-end justify-center gap-8 pt-1 sm:gap-10">
        {alignerProgress.map((a) => {
          const child = children.find((c) => c.id === a.childId);
          if (!child) return null;
          const progress = 1 - a.daysLeft / a.totalDays;
          return (
            <ProgressArc
              key={a.childId}
              progress={progress}
              tone={child.color}
              label={`${a.daysLeft} jours`}
              pill={child.firstName}
            />
          );
        })}
      </div>
    </Card>
  );
}
